<div class="linked-outcomes-container">
    <div class="linked-outcomes-header">
        <button (click)="openLinkOutcomesDialog()">
            <div>
                Link Outcome(s)
            </div>
            <img src="assets/images/icons/link_icon_white.png">
        </button>

        <!-- <a href="https://tnc.box.com/s/tidomhe9q5et2hhrr26979de0pcvubrp" target="_blank">Contributing Outcomes FAQ and Guidance</a> -->
    </div>

    <div class="linked-outcomes-body">
        <h4>Strategy Outcomes</h4>

        @if(strategyLinkedOutcomeTree?.hasOutcomes) {
            @for(linkedOutcomeList of strategyLinkedOutcomeTree.linkedOutcomeLists; track linkedOutcomeList?.goal?.goal2030Id) {
                <app-linked-outcome-table [linkedOutcomeList]="linkedOutcomeList" (removeLinkRequested)="removeLink($event)"></app-linked-outcome-table>
            }
        }
        @else {
            <div class="alert alert-info alert-styled-left shadow-0 ng-star-inserted">
                There are no Linked Strategy Outcomes.
            </div>
        }

        <h4>Project Outcomes</h4>

        @if(projectLinkedOutcomeTree?.hasOutcomes) {
            @for(linkedOutcomeList of projectLinkedOutcomeTree.linkedOutcomeLists; track linkedOutcomeList?.goal?.goal2030Id) {
                <app-linked-outcome-table [linkedOutcomeList]="linkedOutcomeList" (removeLinkRequested)="removeLink($event)"></app-linked-outcome-table>
            }
        }
        @else {
            <div class="alert alert-info alert-styled-left shadow-0 ng-star-inserted">
                There are no Linked Project Outcomes.
            </div>
        }

    </div>

</div>
